module.exports = __webpack_public_path__ + "../resources/img/@temp_chart_6.8506a94c.jpg";